import { SettingApi } from "@kdmanalytics/brm-component";
import BrmApiClient from "services/brm/BrmApiClient";

export const settingsApi = new SettingApi(BrmApiClient.instance);
